import produce from 'immer';
import { IDataControl, IDataFile } from 'interfaces/demographics';
import { SET_DATA_CONTROL_REDUCER, SET_DATA_FILE_UPLOAD_REDUCER } from './actionTypes';

export interface IDataControlState {
  dataControl: IDataControl;
  dataFile?: IDataFile;
}

const initialState: IDataControlState = {
  dataControl: null,
  dataFile: null
};

export const dataControlReducer = (state: IDataControlState = initialState, action: { type: string; data: any }) =>
  produce(state, (draft) => {
    switch (action?.type) {
      case SET_DATA_CONTROL_REDUCER:
        draft.dataControl = action?.data;
        break;
      case SET_DATA_FILE_UPLOAD_REDUCER:
        draft.dataFile = action?.data;
        break;
      default:
        return state;
    }
  });
